export const DASHBOARD_PANEL_DEVICE_OFFLINE = "DASHBOARD_PANEL_DEVICE_OFFLINE";
export const DASHBOARD_PANEL_DEVICE_OFFLINE_RESPONSE = "DASHBOARD_PANEL_DEVICE_OFFLINE_RESPONSE";